export default {"src":"/_next/static/media/data-protection-impact-assessment.29e88230.svg","height":524,"width":524,"blurWidth":0,"blurHeight":0};